import React from 'react';

import { createTheme } from '@material-ui/core';

import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import LandscapeIcon from '@material-ui/icons/Landscape';
import CallSplitIcon from '@material-ui/icons/CallSplit';
//import DeckIcon from '@material-ui/icons/Deck';
import TwoWheelerIcon from '@material-ui/icons/TwoWheeler';
import axios from 'axios';
import { FcmMessage } from '../../appredux';
import CONFIG from '../../cfg/config';
import { AsortMenuWiersz, FcmNotification, SerwisService } from '../../api';

export const wciecie = '  * ';
export const odstep: string = '          ';

let ipAdress = ""


export const normalizeText = (text: string, replacedFor: string = "-", replacePolishLetters: boolean = true): string => {
  let t = text;
  let r = replacedFor;

  t = t.split("/").join(r)
  t = t.split("?").join(r)
  t = t.split("&").join(r)
  t = t.split("|").join(r)
  t = t.split("+").join(r)
  t = t.split("=").join(r)

  if (replacePolishLetters) {
    t = t.replace(/ę/ig, 'e');
    t = t.replace(/ż/ig, 'z');
    t = t.replace(/ó/ig, 'o');
    t = t.replace(/ł/ig, 'l');
    t = t.replace(/ć/ig, 'c');
    t = t.replace(/ś/ig, 's');
    t = t.replace(/ź/ig, 'z');
    t = t.replace(/ń/ig, 'n');
    t = t.replace(/ą/ig, 'a');

    t = t.replace(/Ę/ig, 'E');
    t = t.replace(/Ż/ig, 'Z');
    t = t.replace(/Ó/ig, 'O');
    t = t.replace(/Ł/ig, 'L');
    t = t.replace(/Ć/ig, 'C');
    t = t.replace(/Ś/ig, 'S');
    t = t.replace(/Ź/ig, 'Z');
    t = t.replace(/Ń/ig, 'N');
    t = t.replace(/Ą/ig, 'A');
  }

  return t
}

export const zbudujLiczbeLosowa = (ip: string): string => {
  let date = new Date();
  let h = date.getHours() < 10 ? "0" + date.getHours().toString() : date.getHours().toString();
  let m = date.getMinutes() < 10 ? "0" + date.getMinutes().toString() : date.getMinutes().toString();
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds().toString() : date.getSeconds().toString();
  let ms = date.getMilliseconds() < 10 ? "00" + date.getHours().toString() : date.getMilliseconds() < 100 ? "0" + date.getMilliseconds().toString() : date.getMilliseconds().toString().toString();
  let dateStr: string = h + "." + m + "." + s + "." + ms;

  return (ip ? ip : '0.0.0.0') + "-" + dateStr + "-" + Math.floor(Math.random() * 10000000000).toString();
}

export const obetnijTekst = (tekst: string, dlugosc: number): string => {
  if (tekst.length < dlugosc)
    return tekst;

  let obcietyTekst = tekst.substring(0, dlugosc);
  let index1 = -1;
  let index2 = -1;
  let index3 = -1;
  let index4 = -1;

  for (let i = 0; i < obcietyTekst.length; i++) {
    if (obcietyTekst[i] === '<')
      if (index1 !== -1) {
        index4 = index1;
        index1 = i
      }
      else
        index1 = i;
    else if (obcietyTekst[i] === '>')
      index2 = i;
    else if (obcietyTekst[i] === '/')
      index3 = i;

    if (index1 !== -1 && index2 !== -1 && index3 !== -1)
      if (index2 > index1) {
        index1 = -1;
        index2 = -1;
        index3 = -1;
      }
  }

  if (index1 !== -1)
    if (index4 !== -1)
      obcietyTekst = obcietyTekst.substring(0, index4 - 4);
    else
      obcietyTekst = obcietyTekst.substring(0, index1 - 4);
  else
    obcietyTekst = obcietyTekst.substring(0, obcietyTekst.length - 3);

  return obcietyTekst + '...';
}

export const daysFromDate = (date: Date, days: number): string => {
  // let nextDate = new Date();
  // nextDate.setDate(nextDate.getDate() + days);
  // let mm = nextDate.getMonth() + 1;
  // let dd = nextDate.getDate();
  // let a = [nextDate.getFullYear(), "-",
  // (mm > 9 ? '' : '0') + mm, "-",
  // (dd > 9 ? '' : '0') + dd
  // ].join('');
  // return a

  return new Date(date.getTime() + 86400000 * days).toISOString().slice(0, 10);
}

export const monthsFromDate = (date: Date, month: number): string => {
  // let nextDate = new Date();
  // nextDate.setDate(nextDate.getDate());
  // let mm = nextDate.getMonth() + 1 + month;
  // let dd = nextDate.getDate();
  // let a = [nextDate.getFullYear(), "-",
  // (mm > 9 ? '' : '0') + mm, "-",
  // (dd > 9 ? '' : '0') + dd
  // ].join('');
  // return a

  return new Date(date.setMonth(date.getMonth() + month)).toISOString().slice(0, 10);
};

export const days = (dfrom: Date, dto: Date): number => {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  return Math.floor((dto.valueOf() - dfrom.valueOf()) / _MS_PER_DAY)
}

export const datediff = (first: Date, second: Date): number => {
  return Math.round((second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24));
}

export const sameDayOrLater = (d1: Date, d2: Date): boolean => {
  return sameDay(d1, d2) || later(d1, d2);
}

export const sameDayOrEarlier = (d1: Date, d2: Date): boolean => {
  return sameDay(d1, d2) || earlier(d1, d2);
}

export const later = (d1: Date, d2: Date): boolean => {
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1 > d2;
}

export const earlier = (d1: Date, d2: Date): boolean => {
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1 < d2;
}

export const sameDay = (d1: Date, d2: Date): boolean => {
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1 === d2;
}

export const shallowEqual = (object1: any, object2: any) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
}

//Daje szerokosc paska z napisem na mapie do pomonozenia przez przeskalowanie
//PM 2021-03-15
export const getSzerokoscPaska = (tekst: string): number => {
  const slowa = tekst.split(' ');
  let mnoznik = 0.00054;

  for (const s of slowa)
    //jesli nie strzalka
    if (s.length > 1)
      //jesli cale slowo CAPSem
      if (s === s.toLocaleUpperCase()) {
        //jesli nie zmieniano wczesniej mnoznika
        if (mnoznik === 0.00054)
          mnoznik = 0.000766;
      }
      //jesli nie CAPS i zmieniano mnoznik
      else if (mnoznik > 0.00054) {
        mnoznik = (0.00054 + mnoznik) / 2;
        break;
      }

  return mnoznik * (tekst.length + 2);
}

export const themeExist = (color: string) => {
  if (color != "")
    return true;
  return false

}

export const themeSelect = (color: string) => {
  return createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "14px 5px 14px 16px"
        }
      },
      MuiOutlinedInput: {
        input: {
          padding: "8px 14px",
          textAlign: "center",
          fontWeight: "bold"
        },
        multiline: {
          padding: "0px"
        }
      },
      MuiSelect: {
        selectMenu: {
          fontWeight: 400
        }
      }
    },
    palette: {
      primary: {
        // Purple and green play nicely together.
        main: color as string,
      }
    }
  });
}

export const capitalizeText = (s: string) => s.toLocaleLowerCase().trim().split(" ").map(x => x == "" ? x : x[0].toUpperCase() + x.slice(1)).join(" ");

export const nearestFriday = (date: string | Date): number => {
  let d = new Date(date);
  let dayNumber = d.getDay(); // 0 - 6
  let diff = 0
  if (dayNumber <= 5) {
    diff = 5 - dayNumber;
  } else {
    diff = 6
  }
  return diff;
}

export const weekDay = (date: string | Date): string => {
  let d = new Date(date);
  let dayNumber = d.getDay(); // 0 - 6
  let day = ""
  switch (dayNumber) {
    case 0:
      day = "niedziela"
      break;
    case 1:
      day = "poniedziałek"
      break;
    case 2:
      day = "wtorek"
      break; 
    case 3:
      day = "środa"
      break; 
    case 4:
      day = "czwartek"
      break; 
    case 5:
      day = "piątek"
      break; 
    case 6:
      day = "sobota"
      break; 
    
  }
  return day;
}

//PM 2021-03-26
export const displayListIcon = (krainaId: string) => {
  switch (krainaId) {
    case "1":
      return (<BeachAccessIcon style={{ /*fontSize: "36px",*/ color: "#3a87ad" }} />)
    case "2":
      return (<DirectionsBikeIcon style={{ /*fontSize: "36px",*/ color: "#458B00" }} />)
    case "3":
      return (<LandscapeIcon style={{ /*fontSize: "36px",*/ color: "rgba(191, 136, 85, 0.8)" }} />)
    case "4":
      return (<CallSplitIcon style={{ /*fontSize: "36px",*/ color: "orange" }} />)
    case "5":
      return (<TwoWheelerIcon style={{ /*fontSize: "36px",*/ color: "#c20000" }} />)
    default:
      return (<BeachAccessIcon style={{ /*fontSize: "36px",*/ color: "#3a87ad" }} />)
  }
}

//PM 2021-03-31
export const przedNawiasem = (aString: string) => {
  const nawiasIndex = aString.indexOf('(');

  return aString.substring(0, nawiasIndex - 1);
}

//PM 2021-03-31
export const nawias = (aString: string) => {
  const nawiasIndex = aString.indexOf('(');

  return aString.substring(nawiasIndex);
}

//PM 2021-04-14
export const odmienOsoby = (aCount: number) => {
  return `${aCount} ${aCount < 2 ? "osoba" : aCount < 5 ? "osoby" : "osób"}`;
}

//PM 2021-04-21
export const odmienDni = (aDni: number) => {
  return `${aDni} ${aDni === 1 ? "dzień" : "dni"}`;
}

export const formatDate = (d: Date) => {
  let date = new Date(d);
  let mm = date.getMonth() + 1;
  let dd = date.getDate();
  let a = [date.getFullYear(), "-",
  (mm > 9 ? '' : '0') + mm, "-",
  (dd > 9 ? '' : '0') + dd
  ].join('');
  return a;
}

export const time = (t: number) => {
  return (t < 10 ? "0" + t : t)
};

//PM 2021-08-12
//dodanie sekund
export const dateNowFormatted = () => {
  const now = new Date();

  return [time(now.getFullYear()),
  time(now.getMonth() + 1),
  time(now.getDate()),].join('-') + ' ' +
    [time(now.getHours()),
    time(now.getMinutes()),
    time(now.getSeconds()),].join(':');
};

//PM 2021-08-13
export const downloadQR = (aReservationId: number, aDatoOd: string, aDataDo: string, rodzPokoi: string, iloscOsob: string) => {
  const canvas = document.getElementById("qrCode") as HTMLCanvasElement;
  const pngUrl = canvas
    .toDataURL("image/png")
    .replace("image/png", "image/octet-stream");
  let downloadLink = document.createElement("a");
  downloadLink.href = pngUrl;
  downloadLink.download = `${document.getElementsByTagName("title")[0].innerText.split(' ')[1]} - Rezerwacja id ${aReservationId} - Od ${aDatoOd} - Do ${aDataDo} -  ${capitalizeFirstLetter(rodzPokoi.toLowerCase())} - Osoby ${iloscOsob}.png`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

/**
  * duża pierwsza litera tylko pierwszego wyrazu
  */
export const capitalize = (s: string) => s[0].toUpperCase() + s.slice(1);

//SW 2021-08-25
export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

//PM 2021-10-20
export const getBrowser = () => {
  const nAgt = navigator.userAgent;
  let verOffset: number;
  let nameOffset: number;
  let browser = navigator.appName;

  // Opera
  if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
    browser = 'Opera';
  }
  // Opera Next
  if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
    browser = 'Opera';
  }
  // Legacy Edge
  else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
    browser = 'MicrosoftLegacyEdge';
  }
  // Edge (Chromium)
  else if ((verOffset = nAgt.indexOf('Edg')) !== -1) {
    browser = 'MicrosoftEdge';
  }
  // MSIE
  else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
    browser = 'MicrosoftInternetExplorer';
  }
  // Chrome
  else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
    browser = 'Chrome';
  }
  // Safari
  else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
    browser = 'Safari';
  }
  // Firefox
  else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
    browser = 'Firefox';
  }
  // MSIE 11+
  else if (nAgt.indexOf('Trident/') !== -1) {
    browser = 'MicrosoftInternetExplorer';
  }
  // Other browsers
  else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
    browser = nAgt.substring(nameOffset, verOffset);
    if (browser.toLowerCase() === browser.toUpperCase()) {
      browser = navigator.appName;
    }
  }

  return browser
}

//PM 2021-10-20
export const getSystem = () => {
  const nAgt = navigator.userAgent;
  let os = '-';
  const clientStrings = [
    { s: 'Windows10', r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: 'Windows8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: 'Windows8', r: /(Windows 8|Windows NT 6.2)/ },
    { s: 'Windows7', r: /(Windows 7|Windows NT 6.1)/ },
    { s: 'WindowsVista', r: /Windows NT 6.0/ },
    { s: 'WindowsServer2003', r: /Windows NT 5.2/ },
    { s: 'WindowsXP', r: /(Windows NT 5.1|Windows XP)/ },
    { s: 'Windows2000', r: /(Windows NT 5.0|Windows 2000)/ },
    { s: 'WindowsME', r: /(Win 9x 4.90|Windows ME)/ },
    { s: 'Windows98', r: /(Windows 98|Win98)/ },
    { s: 'Windows95', r: /(Windows 95|Win95|Windows_95)/ },
    { s: 'WindowsNT4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
    { s: 'WindowsCE', r: /Windows CE/ },
    { s: 'Windows3.11', r: /Win16/ },
    { s: 'Android', r: /Android/ },
    { s: 'OpenBSD', r: /OpenBSD/ },
    { s: 'SunOS', r: /SunOS/ },
    { s: 'ChromeOS', r: /CrOS/ },
    { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
    { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
    { s: 'MacOSX', r: /Mac OS X/ },
    { s: 'MacOS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
    { s: 'QNX', r: /QNX/ },
    { s: 'UNIX', r: /UNIX/ },
    { s: 'BeOS', r: /BeOS/ },
    { s: 'OS/2', r: /OS\/2/ },
    { s: 'SearchBot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
  ];
  for (const id in clientStrings) {
    const cs = clientStrings[id];
    if (cs.r.test(nAgt)) {
      os = cs.s;
      break;
    }
  }

  return os
}

export const hexToHSL = (H: string) => {
  // Convert hex to RGB first
  let r : any = 0, g : any = 0, b : any = 0;
  if (H.length == 4) {
    r = "0x" + H[1] + H[1];
    g = "0x" + H[2] + H[2];
    b = "0x" + H[3] + H[3];
  } else if (H.length == 7) {
    r = "0x" + H[1] + H[2];
    g = "0x" + H[3] + H[4];
    b = "0x" + H[5] + H[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r,g,b),
      cmax = Math.max(r,g,b),
      delta = cmax - cmin,
      h = 0,
      s = 0,
      l = 0;

  if (delta == 0)
    h = 0;
  else if (cmax == r)
    h = ((g - b) / delta) % 6;
  else if (cmax == g)
    h = (b - r) / delta + 2;
  else
    h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0)
    h += 360;

  l = (cmax + cmin) / 2;
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return "hsl(" + h + "," + s + "%," + l + "%)";
}

//PM 2021-10-26
/**
 * Funkcja wysyła raport do vscSerwis
 * @param hotelId alias strony
 * @param ktoId identyfikator aplikacji/urządzenia czyli software/hardware
 * @param status 0 - błąd, 1 - działa 
 * @param akcjaNr numer akcji, ujemne dla błędu, dodatnie dla działającej aplikacji
 * @param akcjaOpis opis błędu, lub nazwa akcji np. start, logowanie, okno główne
 * 
 */
export const sendErrorLog = async (status: string, akcjaNr: string, akcjaOpis: string) => {
  try {
    let ip = await getIp()

    await SerwisService.saveReport({
      hotelId: CONFIG.hotelID,
      ktoId: "305",
      adresIP: ip,
      opis: getSystem() + " " + getBrowser(),
      status: status,
      akcjaNr: akcjaNr,
      akcjaOpis: akcjaOpis.length > 50 ? akcjaOpis.substring(0, 50) : akcjaOpis
    }, {})
    //console.log("wysłano raport")
    //console.log(res)

  } catch (error) {
    //console.log("nie wysłano raportu")
    console.log(error)
  }
}

export const getIp = async () : Promise<string> => {
  let ip : string = ""
  if(ipAdress !== ""){ return ipAdress }
  try {
    const resIp: any = await axios.get('https://api.db-ip.com/v2/free/self')
    //ip = resIp.data.split("ip=")[1].split("\n")[0].trim()
    ip = resIp.data.ipAddress
    ipAdress = resIp.data.ipAddress
    
  } catch (error) {
    console.log(error)
  }
  return ip;
}

export const sendFcmErrorLog = async (messages: FcmMessage[]) => {

  try {
    let ip = await getIp()
    let message =  messagesString(messages)
    let res: any = await FcmNotification.sendErrorLog({
      hotelId: "FCM-1",
      aplikacjaId: "305",
      mobileNr: "2",
      tekst: `FCM-1\n\n0\n\n2\n\n${"KelnerBook"}**${CONFIG.hotelID}**${ip}\n\n[${message}]\n\n4`,
    }, {})
    
  } catch (error) {
    console.log(error)
  }
}

export const messagesString = (messages: FcmMessage[]) => {
  return messages.reduce((prev: string, current: FcmMessage, index: number ) => {
    return prev + `${index === 0 ? "" : ", "}{${current.text}, ${current.type}, ${new Date().getTime()}L}`
  }, "")
}

export const sortujAdresyIp = (a: string, b: string) => {
  const num1 = Number(a.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
  const num2 = Number(b.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
  return num1 - num2;
}

export const range = (start: number, end: number, step: number) => {
  let range: number[] = [];

  if (step === 0) {
    throw TypeError("Step cannot be zero.");
  }

  if (end < start) {
    step = -step;
  }

  while (step > 0 ? end >= start : end <= start) {
    range.push(start);
    start += step;
  }

  return range;

}

export const phoneSplit = (phone: string): string => {
  let p = phone.trim()
  if(p.length !== 9) return phone
  return p.slice(0, 3) + " " + p.slice(3, 6) + " " + p.slice(6, 9)
}

export const hexToRgb = (hex: string) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export const dostepnePrioryety = (p: AsortMenuWiersz[], id: number ): number[] => {
  let dostepnePriorytety = p.filter(x => x.menu_id === id).map((e) => Number(e.priorytet))
  let priorytety = dostepnePriorytety.filter((x, i, a) => a.indexOf(x) == i).sort()
  if(priorytety && priorytety[priorytety.length -1] === 99){ priorytety.pop() } //priorytet 99 ignorujemy
  return priorytety
}